import axios from "axios";
 

export const getData = (params) => (dispatch)=>{
    dispatch({type:"FETCH_REQUEST"})
    let obj = {
        params
    } 
    axios.get(`https://wearwave-server.onrender.com/prods?_page=0&_limit=8`,obj).then((res)=>{
        dispatch({type: "FETCH_SUCESS", payload: res.data})
        console.log(res.data);
    }).catch((err)=>{
        dispatch({type: "FETCH_FAILURE", payload: err.massage})
        // console.log(err);
    });
}